/*
 * Copyright (c) 2021-2021. Datafood srl
 * Developed by Revo Digital - revodigital.it
 * ---
 * Author: leonardoviada
 * File: ProjectCard.tsx
 * Project: mle-client
 * Committed last: 2021/11/11 @ 1733
 * ---
 */

import { Button, Card, Spinner, Tag }                    from '@blueprintjs/core';
import {
  LabelPaths
}                                                        from '../paths/label.paths';
import {
  Link
}                                                        from 'react-router-dom';
import { Label }                                         from '../entities';
import React, { useEffect, useState }                    from 'react';
import {
  ColorMode,
  Decoder,
  Metadata
}                                                        from '@revodigital/mpes/lib';
import {
  DeletionConfirmPopver
}                                                        from './common/overlay/DeletionConfirmPopver';
import { MeasureUnits, MetadataGroupKeys, MetadataKeys } from '../common/enums';
import {
  measureUnitToMeasureUnit
}                                                        from '../common/measure-unit-utils';
import {
  IRawData
}                                                        from '@revodigital/mpes';

export interface ProjectCardProps {
  label: Label;
  onDelete: (labelId: number) => void;
}

export const ProjectCard = (props: ProjectCardProps) => {
  const [ decodedData, setDecodedData ] = useState<IRawData>();

  useEffect(() => {
    (async () => {
      const encoder = new Decoder();
      const decodedData = await encoder.decodeBuffer(props.label.bodyContent);

      setDecodedData(decodedData);
    })();
  }, [ props.label ]);

  const getMeasureUnit = (decodedData: IRawData) => {
    if (decodedData.metadata) {
      const m = new Metadata(decodedData.metadata);
      return m.getKeyValueOfGroup<MeasureUnits>(
        MetadataGroupKeys.TEXT_BASED,
        MetadataKeys.MEASURE_UNIT) ?? MeasureUnits.MM;
    }
    return MeasureUnits.MM;
  };

  return (
    <Card className="mle-project-card p-0 col-span-1">
      <div className="mle-project-card-side-bar">
        <div className="mle-project-card-side-btns">
          <DeletionConfirmPopver
            onConfirm={ () => props.onDelete(props.label.id) }>
            <Button
              minimal
              icon="trash"
            />
          </DeletionConfirmPopver>
          <Button minimal icon="eye-open" disabled/>
          <Button minimal icon="cloud-download" disabled/>
        </div>
      </div>
      <div className="p-4">
        <Link to={ LabelPaths.ROOT + '/' + props.label.id }>
          <h5 className="bp4-heading">{ props.label.title }</h5>
        </Link>
        <p className="-mt-2 bp4-text-muted">Progetto Cloud - Modificato {
          new Date(props.label.lastModified).toLocaleDateString('it-IT')
        }</p>
        <div className="h-5"/>
        {
          decodedData ? <span>
        <Tag minimal intent="primary" icon="document"
             className="mr-2">{ measureUnitToMeasureUnit(MeasureUnits.PX,
          getMeasureUnit(decodedData),
          decodedData.canvasprops.width) }x{ measureUnitToMeasureUnit(
          MeasureUnits.PX,
          getMeasureUnit(decodedData),
          decodedData.canvasprops.height) }{ getMeasureUnit(decodedData) }</Tag>
        <Tag minimal intent="success" icon="tint"
             className="mr-2">{ decodedData.canvasprops.colorMode === ColorMode.WithColor ? 'Colore' : 'B/N' }</Tag>
                      </span> : <Spinner size={ 15 }/>
        }
      </div>
    </Card>
  );
};
